import { Component, Input, OnInit } from '@angular/core';
import { TransactionRequirementService } from 'src/app/pages/transaction/services/transaction-requirement.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';
import { BaseManagement } from 'src/app/core/services/base-management';
import { DialogOkComponent } from '../dialog-ok/dialog-ok.component';
import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';
import { TransactionService } from 'src/app/pages/transaction/services/transaction.service'
@Component({
  selector: 'document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss']
})

export class DocumentViewerComponent extends BaseManagement implements OnInit {
	@Input() validateForm = false;
	isPDF: boolean = false;
	serverError: any = '';
	isFormValid: boolean = false;
	constructor(
		public mainService: TransactionRequirementService, 
		public translate: TranslateService,		
		public ngxService: NgxExtendedPdfViewerService,
		public transactionService: TransactionService,
	) {
		super();
	}
	checkIfPDF(){
		if (typeof this.mainService.fileToLoad === 'string'){
			let extension = this.getFileExtension(this.mainService.fileToLoad);
			this.isPDF = extension.toLowerCase() === 'pdf';
		}		
	  }
	getFileExtension(fileName: string): string {
		const parts = fileName.split('.');
		return parts[parts.length - 1];
	}

	ngOnInit() {	
		this.checkIfPDF();
		console.log('validateForm:', this.validateForm);
		console.log(this.mainService.currentRequirement.PdfFormJson);
		console.log('this.mainService.fileToLoad: ' +  this.mainService.fileToLoad);
		console.log(this.transactionService.itemToEdit.AssignedToCurrentUser);
		// Patch PDF form data if available
		this.patchPdfFormData();
		
		// Validate form after patching data
		setTimeout(() => {
			this.validateFormManually();
		}, 1000); // Wait for PDF viewer to load
	}

	private patchPdfFormData(): void {
		if (this.mainService.currentRequirement && this.mainService.currentRequirement.PdfFormJson) {
			try {
				const formData = JSON.parse(this.mainService.currentRequirement.PdfFormJson);
				this.mainService.formData = formData;
				console.log('PDF form data patched:', formData);
			} catch (error) {
				console.error('Error parsing PdfFormJson:', error);
			}
		}
	}

	// Manual validation method
	async validateFormManually(): Promise<void> {
		console.log('validateFormManually called, validateForm:', this.validateForm);
		
		if (!this.validateForm) {
			this.isFormValid = true;
			console.log('Validation disabled, setting isFormValid to true');
			return;
		}

		try {
			const formData: any[] = await this.ngxService.getFormData();
			console.log('Form data retrieved:', formData);
			
			const missingFields: string[] = [];

			for (const field of formData) {
				const fieldValue = field.fieldAnnotation && field.fieldAnnotation.value ? field.fieldAnnotation.value : '';
				console.log('Checking field:', field.name, 'value:', fieldValue);
				
				// Check if field name contains "required" and if the field is empty
				if (field.name && field.name.toLowerCase().includes('required')) {
					const isEmpty = !fieldValue || fieldValue.trim() === '';
					console.log('Required field:', field.name, 'isEmpty:', isEmpty);
					
					if (isEmpty) {
						missingFields.push(field.name);
					}
				}
			}

			this.isFormValid = missingFields.length === 0;
			console.log('Missing fields:', missingFields);
			console.log('isFormValid:', this.isFormValid);
		} catch (error) {
			console.error('Error during form validation:', error);
			this.isFormValid = false;
		}
	}

 	close(){
 		this.mainService.fileToLoad = null;
 	} 

	tryUpdateFormData(action) {
		console.log('tryUpdateFormData called, isFormValid:', this.isFormValid);
		
		if (!this.isFormValid) {
			this.alertCompleteForm();
			return;
		}

		if (this.isSaving()) return;

		this.translate
			.get([
				'message.deleteConfirmText',
				'message.yes',
				'message.no',
				'message.requirement',
				'message.deleted',
				'message.unableRequirement',
				'message.done',
				'pdfform.saveWarn',
			])
			.subscribe((translations) => {
				const dialogRef = this.dialog.open(DialogYesNoComponent, {
					width: '250px',
					data: {
						msg: translations['pdfform.saveWarn'],
						yesText: translations['message.yes'],
						noText: translations['message.no'],
					},
				});

				dialogRef.afterClosed().subscribe((result) => {
					if (result === 1) {
						this.startSaving(action);
						this.updateFormData(action);
					}
				});
			});
	}

	public async updateFormData(action : any): Promise<void> {
		
			var formData = new FormData();
			var files: File[] = [];
			Array.from(files).forEach((f) => formData.append('file', f));
			let params: any = [];
			params.userProcessId = this.mainService.currentRequirement.ProcessId;
			params.userProcessRequirementId = this.mainService.currentRequirement.UserProcessRequirementId;
			
			// Convertir saltos de línea a etiquetas HTML <br>
			console.log('📋 Datos originales:', this.mainService.formData);
			const sanitizedFormData = this.convertNewLinesToHtml(this.mainService.formData);
			console.log('✅ Datos con <br>:', sanitizedFormData);
			formData.append('pdfFormJson', JSON.stringify(sanitizedFormData));
			this.mainService.updatePdfFormInternal(params, formData)
			.then((updatedRequirement: any) => {

				// this.mainService.pdfCommunicator.next("stop-saving");
				this.stopSaving();
				this.mainService.currentRequirement = updatedRequirement.Data;

				this.mainService.updateItemByField(
					this.mainService.currentRequirement.UserProcessRequirementId,
					'UserProcessRequirementId',
					this.mainService.currentRequirement
				);
				this.close();
			})
			.catch((err) => {
				console.log('error', err);
				this.translate
					.get(['error.documentUplaod'])
					.subscribe((translations) => {
						this.stopSaving();

						this.serverError = "Hubo un problema al intentar enviar el documento"
					});
			});
	}

	async onFormChange(event: any) {
		console.log('onFormChange triggered');
		await this.validateFormManually();
	}

	alertCompleteForm() {
		const dialogRef = this.dialog.open(DialogOkComponent, {
			data: {
				msg: 'Rellene todos los campos obligatorios.',
			}
		});

		dialogRef.afterClosed().subscribe((res: any) => { });
	}

	/**
	 * Convierte los saltos de línea (\n) a etiquetas HTML <br> para que se 
	 * muestren correctamente en el PDF generado
	 * @param data Objeto con los datos del formulario
	 * @returns Objeto con los datos convertidos
	 */
	private convertNewLinesToHtml(data: any): any {
		const converted: any = {};
		
		for (const key in data) {
			if (data.hasOwnProperty(key)) {
				let value = data[key];
				
				// Si es un string, convertir saltos de línea a <br>
				if (typeof value === 'string') {
					// Normalizar diferentes tipos de saltos de línea
					value = value.replace(/\r\n/g, '\n'); // Windows
					value = value.replace(/\r/g, '\n');   // Mac antiguo
					
					// Convertir \n a <br>
					value = value.replace(/\n/g, '<br>');
				}
				
				converted[key] = value;
			}
		}
		
		return converted;
	}
	
}
